import React from "react";

const KeyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_190_528"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_190_528)">
        <path
          d="M8.74935 5.83301C8.74935 5.37467 8.91254 4.98231 9.23893 4.65592C9.56532 4.32954 9.95768 4.16634 10.416 4.16634C10.8743 4.16634 11.2667 4.32954 11.5931 4.65592C11.9195 4.98231 12.0827 5.37467 12.0827 5.83301C12.0827 6.29134 11.9195 6.6837 11.5931 7.01009C11.2667 7.33648 10.8743 7.49967 10.416 7.49967C9.95768 7.49967 9.56532 7.33648 9.23893 7.01009C8.91254 6.6837 8.74935 6.29134 8.74935 5.83301ZM5.41602 5.83301C5.41602 4.44412 5.90213 3.26356 6.87435 2.29134C7.84657 1.31912 9.02713 0.833008 10.416 0.833008C11.8049 0.833008 12.9855 1.31912 13.9577 2.29134C14.9299 3.26356 15.416 4.44412 15.416 5.83301C15.416 6.76356 15.1868 7.60731 14.7285 8.36426C14.2702 9.1212 13.666 9.7219 12.916 10.1663V17.1455C12.916 17.2566 12.8952 17.3643 12.8535 17.4684C12.8118 17.5726 12.7493 17.6663 12.666 17.7497L10.9993 19.4163C10.916 19.4997 10.8257 19.5587 10.7285 19.5934C10.6313 19.6281 10.5271 19.6455 10.416 19.6455C10.3049 19.6455 10.2007 19.6281 10.1035 19.5934C10.0063 19.5587 9.91602 19.4997 9.83268 19.4163L7.18685 16.7705C7.1174 16.7011 7.06185 16.6177 7.02018 16.5205C6.97852 16.4233 6.95074 16.3261 6.93685 16.2288C6.92296 16.1316 6.9299 16.0344 6.95768 15.9372C6.98546 15.84 7.03407 15.7497 7.10352 15.6663L7.91602 14.583L7.02018 13.3955C6.96463 13.3261 6.92296 13.2497 6.89518 13.1663C6.8674 13.083 6.85352 12.9997 6.85352 12.9163C6.85352 12.833 6.8674 12.7462 6.89518 12.6559C6.92296 12.5656 6.96463 12.4858 7.02018 12.4163L7.91602 11.1455V10.1663C7.16602 9.7219 6.56185 9.1212 6.10352 8.36426C5.64518 7.60731 5.41602 6.76356 5.41602 5.83301ZM7.08268 5.83301C7.08268 6.61079 7.31879 7.29481 7.79102 7.88509C8.26324 8.47537 8.86046 8.86773 9.58268 9.06217V11.6663L8.72852 12.8747L9.99935 14.583L8.85352 16.0622L10.416 17.6247L11.2493 16.7913V9.06217C11.9716 8.86773 12.5688 8.47537 13.041 7.88509C13.5132 7.29481 13.7493 6.61079 13.7493 5.83301C13.7493 4.91634 13.423 4.13162 12.7702 3.47884C12.1174 2.82606 11.3327 2.49967 10.416 2.49967C9.49935 2.49967 8.71463 2.82606 8.06185 3.47884C7.40907 4.13162 7.08268 4.91634 7.08268 5.83301Z"
          fill="#505050"
        />
      </g>
    </svg>
  );
};

export default KeyIcon;
